import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { incrementStep, decrementStep, setFormData } from '../redux/actions';
import { BackArrow } from "../../shared/svgIcons.jsx";
import RadioButton from '../../shared/RadioButton/index.jsx';
import Comps from '@owenscorning/react-library';

const AddressGroup = Comps.Connect.FormElements.AddressGroup

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
  }
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  padding: .5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;


const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: .5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const RadioContainer = styled.div`
  border: 1px solid #6D6D6D;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const Step6 = ( { incrementStep, decrementStep, formData, setFormData } ) => {
  const validated = (formData.ownerAddressSameAsProperty === "true") || (formData.ownerAddress.street && formData.ownerAddress.city && formData.ownerAddress.state && formData.ownerAddress.zip);

  return(
    <>
      <StepWrapper>
        <BackWrapper
          data-track="form-back"
          data-track-form-name="Warranty Registration"
          data-track-form-step="step 6 - what is your mailing address"
          onClick={decrementStep}>
          <BackArrow width="21" height="12" />
          <h3>Back</h3>
          <BackText>Where was the roof installed?</BackText>
        </BackWrapper>
        <p>{formData.propertyAddress.street}, {formData.propertyAddress.city}, {formData.propertyAddress.state} {formData.propertyAddress.zip}</p>
        <Header>
          {formData.registrantType === 'homeowner' ?
            "Is this also your mailing address?"
            :
            "Is this also the mailing address for the homeowner?"
          }
          </Header>
        <RadioContainer>
          <RadioButton
            value={'true'}
            fieldKey={'ownerAddressSameAsProperty'}
            htmlAttributes={{}}
          >
            <label>Yes</label>
          </RadioButton>
        </RadioContainer>
        <RadioContainer>
          <RadioButton
            value={'false'}
            fieldKey={'ownerAddressSameAsProperty'}
            htmlAttributes={{}}
          >
            <label>No</label>
          </RadioButton>
        </RadioContainer>
        {(formData.ownerAddressSameAsProperty === "false") &&
          <>
            <Header>
              {formData.registrantType === 'homeowner' ?
                "What is your mailing address?"
                :
                "What is the mailing address for the homeowner?"
              }
            </Header>
            <AddressGroup
              value={formData.ownerAddress}
              onChange={(address) => { setFormData({ ownerAddress: address }) }}
              suggestionEndpoint={MDMS_URL + '/api/v1/smarty/suggestions'}
              showComplaints={false}
              country={'US'}
            />
          </>
        }
        <NextButton
          data-track="form-advance"
          data-track-form-name="Warranty Registration"
          data-track-form-step="step 6 - what is your mailing address"
          onClick={incrementStep} disabled={!validated}>Next</NextButton>
      </StepWrapper>
    </>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step6);
